/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Donatekey_Success1Inputs */

const id_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berhasil`)
};

const ms_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berjaya`)
};

const da_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Succes`)
};

const de_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfolg`)
};

const en_us2_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Success`)
};

const es_es2_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Éxito`)
};

const es_mx2_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Éxito`)
};

const fil_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tagumpay`)
};

const fr_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Succès`)
};

const it_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Successo`)
};

const hu_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siker`)
};

const nl_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Succes`)
};

const no_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suksess`)
};

const pl_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sukces`)
};

const pt_br2_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Success`)
};

const pt_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sucesso`)
};

const ro_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Succes`)
};

const fi_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onnistui`)
};

const sv_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lyckades`)
};

const vi_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thành công`)
};

const tr_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başarılı`)
};

const cs_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úspěch`)
};

const bg_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Успех`)
};

const ru_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Успешно`)
};

const uk_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Успіх`)
};

const ar_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نجاح`)
};

const hi_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सफल`)
};

const th_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สำเร็จ`)
};

const ja_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成功`)
};

const zh_cn2_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Success`)
};

const zh_hant1_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Success`)
};

const ko_forms_donatekey_success1 = /** @type {(inputs: Forms_Donatekey_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Success`)
};

/**
* | output |
* | --- |
* | "Success" |
*
* @param {Forms_Donatekey_Success1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_donatekey_success1 = /** @type {((inputs?: Forms_Donatekey_Success1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Donatekey_Success1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_donatekey_success1(inputs)
	if (locale === "ms") return ms_forms_donatekey_success1(inputs)
	if (locale === "da") return da_forms_donatekey_success1(inputs)
	if (locale === "de") return de_forms_donatekey_success1(inputs)
	if (locale === "en-US") return en_us2_forms_donatekey_success1(inputs)
	if (locale === "es-ES") return es_es2_forms_donatekey_success1(inputs)
	if (locale === "es-MX") return es_mx2_forms_donatekey_success1(inputs)
	if (locale === "fil") return fil_forms_donatekey_success1(inputs)
	if (locale === "fr") return fr_forms_donatekey_success1(inputs)
	if (locale === "it") return it_forms_donatekey_success1(inputs)
	if (locale === "hu") return hu_forms_donatekey_success1(inputs)
	if (locale === "nl") return nl_forms_donatekey_success1(inputs)
	if (locale === "no") return no_forms_donatekey_success1(inputs)
	if (locale === "pl") return pl_forms_donatekey_success1(inputs)
	if (locale === "pt-BR") return pt_br2_forms_donatekey_success1(inputs)
	if (locale === "pt") return pt_forms_donatekey_success1(inputs)
	if (locale === "ro") return ro_forms_donatekey_success1(inputs)
	if (locale === "fi") return fi_forms_donatekey_success1(inputs)
	if (locale === "sv") return sv_forms_donatekey_success1(inputs)
	if (locale === "vi") return vi_forms_donatekey_success1(inputs)
	if (locale === "tr") return tr_forms_donatekey_success1(inputs)
	if (locale === "cs") return cs_forms_donatekey_success1(inputs)
	if (locale === "bg") return bg_forms_donatekey_success1(inputs)
	if (locale === "ru") return ru_forms_donatekey_success1(inputs)
	if (locale === "uk") return uk_forms_donatekey_success1(inputs)
	if (locale === "ar") return ar_forms_donatekey_success1(inputs)
	if (locale === "hi") return hi_forms_donatekey_success1(inputs)
	if (locale === "th") return th_forms_donatekey_success1(inputs)
	if (locale === "ja") return ja_forms_donatekey_success1(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_donatekey_success1(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_donatekey_success1(inputs)
	return ko_forms_donatekey_success1(inputs)
});
export { forms_donatekey_success1 as "forms.donateKey.success" }